import { Injectable } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import { REG_EXP } from '@com-delta-idp/mnx-sitewide-shared-utils';
import { showError } from '../mocks/check-in-widget.mocks';
import { CheckInWidget, ShowError } from '../models/check-in-widget.interfaces';
import { CHECK_IN_TRIP_BY } from '../models/constants/check-in-constants';
@Injectable({
  providedIn: 'root'
})
export class CheckInWidgetBaseService {
  hideIcon = true;
  hideLastName = true;
  errorContent: ShowError = showError;

  updateVisibilityFlags(title: string): void {
    const isCreditCard = title === CHECK_IN_TRIP_BY.CREDIT_CARD_NUMBER;
    const isSkymiles = title === CHECK_IN_TRIP_BY.SKYMILES_NUMBER;
    this.hideLastName = !isCreditCard;
    this.hideIcon = !(isCreditCard || isSkymiles);
  }

  resetErrorState(): void {
    this.errorContent.showTripTypeError = false;
    this.errorContent.showLastNameError = false;
    this.errorContent.showOriginAirportError = false;
    this.errorContent.showAlert = false;
  }

  getTripTypeError(
    content: CheckInWidget,
    errorType: 'required' | 'invalid',
    tripByValue: string
  ): string {
    const errorMap: Record<string, { required: string; invalid: string }> = {
      'Confirmation Number': {
        required: content.errors.confirmationNumber.required,
        invalid: content.errors.confirmationNumber.invalid
      },
      'Credit Card Number': {
        required: content.errors.creditCardNumber.required,
        invalid: content.errors.creditCardNumber.invalid
      },
      'Ticket Number': {
        required: content.errors.ticketNumber.required,
        invalid: content.errors.ticketNumber.invalid
      },
      'SkyMiles Number': {
        required: content.errors.skymiles.required,
        invalid: content.errors.skymiles.invalid
      }
    };
    const title = tripByValue;
    return (
      errorMap[title]?.[errorType] ||
      errorMap[CHECK_IN_TRIP_BY.CONFIRMATION_NUMBER][errorType]
    );
  }

  getValidatorsForTripType(tripBy: string): ValidatorFn[] {
    const defaultValidators = [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(6),
      Validators.pattern(REG_EXP.NEW_CONFIRMATION_NUMBER)
    ];

    const validatorMap: Record<string, ValidatorFn[]> = {
      [CHECK_IN_TRIP_BY.CONFIRMATION_NUMBER]: defaultValidators,
      [CHECK_IN_TRIP_BY.CREDIT_CARD_NUMBER]: [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(16),
        Validators.pattern(REG_EXP.CREDIT_TICKET_SKYMILES_NUMEBER)
      ],
      [CHECK_IN_TRIP_BY.SKYMILES_NUMBER]: [
        Validators.required,
        Validators.maxLength(10),
        Validators.pattern(REG_EXP.CREDIT_TICKET_SKYMILES_NUMEBER)
      ],
      [CHECK_IN_TRIP_BY.TICKET_NUMBER]: [
        Validators.required,
        Validators.minLength(13),
        Validators.maxLength(14),
        Validators.pattern(REG_EXP.CREDIT_TICKET_SKYMILES_NUMEBER)
      ]
    };
    return validatorMap[tripBy] || defaultValidators;
  }
}
